import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaH6Props extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
}

class KuikaH6 extends Component<KuikaH6Props> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <h6 className={classNames("kuika-typography-h6", className)} {...props}>
        {children}
      </h6>
    );
  }
}

export default KuikaH6;
